// extracted by mini-css-extract-plugin
module.exports = {"header":"cDZWO4Lg","title":"CYsundPy","more":"CkJfoOX9","swiper":"vwb02Jrs","icon":"cneoNT3M","list":"mHO4Avim","loadingContent":"eYNQtAPt","skeletonCard":"o0SR8sOf"};